import { Button, DataHeader, DataSource, Layout, Panel, Switch, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierQualificationProfile extends Layout {
    buttonOpenClassic: Button;
    dataheaderCarrierQualProfile: DataHeader;
    panelGeneral: Panel;
    sourceBrkQualDetail: DataSource;
    sourceBrkQualProfile: DataSource;
    switchActive: Switch;
    tabDetails: Tab;
    tabGeneral: Tab;
    tableCarrierQualDetails: Table;
    tabsetMain: Tabset;
    textboxDescr: Textbox;
    textboxDisqualifiedPts: Textbox;
    textboxId: Textbox;
    textboxWarningLevelPts: Textbox;
}
